import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import "./styles/tokens.css";
import "./styles/app.css";

// Cross-subdomain SSO: account-ui can hand us a session via URL fragment.
(function importFragmentSession() {
  const hash = window.location.hash;
  if (!hash || !hash.includes("access_token=")) return;
  const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
  const access = params.get("access_token");
  const refresh = params.get("refresh_token");
  if (access) {
    try {
      // Stub account until /auth/me lands post-render; role check happens server-side.
      const existing = sessionStorage.getItem("prism-admin-session");
      if (!existing) {
        sessionStorage.setItem("prism-admin-session", JSON.stringify({
          access_token: access,
          refresh_token: refresh ?? "",
          account: { id: "", email: "", display_name: "", role: "admin" },
        }));
      }
      history.replaceState(null, "", window.location.pathname + window.location.search);
    } catch { /* ignore */ }
  }
})();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
